type Num = number | string | null | undefined;

function matchFilterNumber(number: Num, filterNumber?: number) {
  if (filterNumber) return Number(number) === Number(filterNumber)
  return true
}

export default matchFilterNumber
